import React from 'react';
import { Box, Button, Stack, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { SquareImage } from 'features/companies/components/SquareImage';
import { BannerImage } from 'features/companies/components';
import { paths } from 'routes';
import { useLocale } from 'i18n/useLocale';
import { ImageAvatar } from 'components/Avatar';

const getFirstSentences = (text, sentenceCount = 3) => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  const sentenceRegex = /.+?[.?!]\s*/g;
  const sentences = text.match(sentenceRegex);
  if (!sentences) {
    return text;
  }

  return sentences.slice(0, sentenceCount).join('').trim();
};

export const SmallProfile = ({
  company_name,
  square_logo_url = '',
  banner_logo_url = '',
  description = '',
  slug = '',
  company_id = null,
  company_type = 'buyer',
}) => {
  const lang = useLocale();

  if (company_name.length === 0 || description.length === 0 || square_logo_url.length === 0 || banner_logo_url.length === 0) {
    return null;
  }

  return (
    <Stack
      direction={"column"}
      gap={2}
      sx={{
        border: "1px solid",
        borderRadius: 1,
        borderColor: "border.jobAd",
        p: 1,
        maxHeight: 200,
      }}
    >
      <Link
      component={RouterLink}
      to={slug ? paths.public.companyPublicProfile(company_type, slug, lang) : paths.suppliersDetailsView(company_id)}
      color="inherit"
      underline="none"
    >
      <Stack
        sx={{
          maxHeight: 201,
        }}
      >
          <BannerImage
            banner={banner_logo_url}
            sx={{
              width: "100%",
              minHeight: "unset",
              maxHeight: {xs: "91px", md: "45px"},
              border: "1px solid",
              borderRadius: 1,
              borderColor: "border.jobAd"
            }}
            pointer
          />
          <Stack direction="row">
            <SquareImage
              image={square_logo_url}
              wrapperSx={{
                ml:{xs: 1, md: 1, lg: 1.5, xl: 2},
                width:{xs: 30, sm: 40, md: 25, lg: 40, xl: 50},
                height:{xs: 30, sm: 40, md: 25, lg: 40, xl: 50},
              }}
              sx={{
                width:{xs: 30, sm: 40, md: 25, lg: 40, xl: 50},
                height:{xs: 30, sm: 40, md: 25, lg: 40, xl: 50},
                bottom: "50%",
              }}
            
            />
            
            <Stack flex={1} direction={"row"}>
              <Box
                px={{xs: 4, md: 2, xl: 4}}
                height={70}
                sx={{
                  justifyContent: 'space-between',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Stack position="relative" flexDirection="column" bottom={{xs: "15%", md: "25%", xl: "20%"}}>
                  <Stack position="relative" flexDirection="row" gap={1}>
                    <Typography
                      variant='h3'
                      fontWeight={600}
                      color='text.black'
                      lineHeight={"normal"}
                      letterSpacing={"normal"}
                      fontSize={{xs: '1.125rem', md: '0.875rem', xl: "1.125rem"}}
                    >
                      {company_name}
                      </Typography>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          </Stack>
      </Stack>
      <Stack
        gap={2.5}
        marginTop={{xs: "-6%", md: "-12.5%", lg: "-10%", xl: "-7.5%"}}
      >
        <Typography
          variant='body4'
          fontWeight={400}
          fontSize={{xs: "0.875rem", md: "0.75rem", xl: "0.875rem"}}
          color='text.black'
          letterSpacing={"normal"}
          sx={{
            fontFeatureSettings: `'liga' off, 'clig' off`,
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 4,
          }}
        >
          {getFirstSentences(description)}
        </Typography>
      </Stack>
      </Link>
    </Stack>
  );
}